.pdpReviewsSummaryTitle {
  margin-bottom: 8px;
}

.pdpReviewsPercentageBar {
  flex-basis: 140px;
  flex-grow: 1;
  height: 8px;
  border-radius: 12px;
  background-color: var(--colors-grays-light);
}

.pdpReviewsPercentageBarContent {
  height: 8px;
  border-radius: 12px;
  background-color: var(--colors-brand-gold-main);
}

.pdpReviewsSummary {
  background-color: var(--colors-background);
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  margin-top: 24px;
}

@media all and (--reefer-media-tablet-min) {
  .pdpReviewsSummary {
    background-color: unset;
    padding: 0px;
    margin-top: 0px;
  }

  .pdpReviewsSummaryTitle {
    margin-bottom: 16px;
  }

  .pdpReviewsSummaryPercentages {
    border: 1px solid var(--colors-grays-light);
    border-radius: var(--btn-primary-border-radius);
    padding: 32px;
  }
}
